import { render } from "./ChatView.vue?vue&type=template&id=422c0b28&scoped=true&ts=true"
import script from "./ChatView.vue?vue&type=script&lang=ts"
export * from "./ChatView.vue?vue&type=script&lang=ts"

import "./ChatView.vue?vue&type=style&index=0&id=422c0b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422c0b28"]])

export default __exports__